import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Link,
  ListItemText,
  makeStyles,
  Menu,
  MenuItem
} from "@material-ui/core";
import ChevronDownIcon from "mdi-material-ui/ChevronDown";

const useStyles = makeStyles((theme) => ({
  button: {
    whiteSpace: "nowrap"
  },
  menuLabel: {
    maxWidth: 320,
    whiteSpace: "normal"
  },
  controlLabel: {
    marginRight: 0,
    width: "100%"
  },
  footer: {
    padding: theme.spacing(1, 2)
  }
}));

export default function ColumnVisibilityMenu({
  columns,
  onShowAll,
  onToggleColumn,
  title,
  visibleColumnIds
}) {
  const classes = useStyles();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const hideableColumns = columns.filter((column) => column.hideable !== false);

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <Button
        ref={anchorRef}
        variant="outlined"
        color="primary"
        className={classes.button}
        onClick={() => setOpen((previous) => !previous)}
      >
        {title}
        <Box display="flex" paddingLeft={1}>
          <ChevronDownIcon />
        </Box>
      </Button>
      <Menu
        MenuListProps={{ disablePadding: true }}
        anchorEl={anchorRef.current}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        <MenuItem disabled>
          <Box className={classes.menuLabel}>
            <ListItemText primary={title} secondary="Select visible columns" />
          </Box>
        </MenuItem>
        {hideableColumns.map((column) => (
          <MenuItem key={column.id}>
            <FormControlLabel
              className={classes.controlLabel}
              control={(
                <Checkbox
                  color="primary"
                  checked={visibleColumnIds.includes(column.id)}
                  onChange={() => onToggleColumn(column.id)}
                />
              )}
              label={column.label}
            />
          </MenuItem>
        ))}
        <Box className={classes.footer}>
          <Link component="button" variant="body2" onClick={onShowAll}>
            Show all columns
          </Link>
        </Box>
      </Menu>
    </>
  );
}

ColumnVisibilityMenu.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    hideable: PropTypes.bool,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  onShowAll: PropTypes.func.isRequired,
  onToggleColumn: PropTypes.func.isRequired,
  title: PropTypes.string,
  visibleColumnIds: PropTypes.arrayOf(PropTypes.string).isRequired
};

ColumnVisibilityMenu.defaultProps = {
  title: "Columns"
};
